import Reveal from './Reveal';
import { STUDIO } from '@/content/studio';

/**
 * Band 2 — RED STATEMENT. One sentence, set like a poster. Nothing else.
 */

const StatementBand = () => {
    return (
        <section className="hb-statement" aria-label="Studio statement">
            <Reveal>
                <h2 className="hb-statement-text">{STUDIO.statement}</h2>
                <p className="hb-statement-foot">— {STUDIO.tagline.toUpperCase()}</p>
            </Reveal>

            <style>{`
                .hb-statement {
                    background: var(--et-bg);
                    color: var(--paper);
                    padding: var(--by) var(--bx);
                }
                .hb-statement-text {
                    font-family: var(--font-display);
                    font-weight: 700;
                    font-size: clamp(3.2rem, 10.5vw, 9.5rem);
                    line-height: 0.92;
                    letter-spacing: 0.005em;
                    text-transform: uppercase;
                    color: var(--paper);
                    max-width: 24ch;
                    margin: 0;
                    text-wrap: balance;
                }
                /* Surgical red accent — the studio tagline, set in the brand red. */
                .hb-statement-foot {
                    font-family: var(--font-mono);
                    font-size: 0.7rem;
                    font-weight: 700;
                    letter-spacing: 0.26em;
                    color: var(--color-accent-secondary);
                    margin: clamp(1.6rem, 4vw, 2.8rem) 0 0;
                }
            `}</style>
        </section>
    );
};

export default StatementBand;
